import { useState } from "react";
import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import { UploadSolidV6 } from "@shared/v2/Icomoon";
import BaseEvent from "./BaseEvent";

const TimelineDocumentEvent = ({ event }) => {
  const [showModal, setShowModal] = useState(false);
  const from = event.timeline_fields.uploader_name;
  const action = event.event_type === "document_destroyed" ? "deleted" : "uploaded";

  const title = (
    <div>
      <span className="tw-font-semibold">{from}</span>
      {` ${action} a document`}
    </div>
  );

  const content = (
    <>
      <div className="tw-font-semibold">Details:</div>
      <div>
        Document Name:{" "}
        <a href={event.timeline_fields.document_url} target="_blank" rel="noopener noreferrer">
          {event.timeline_fields.document_name}
        </a>
      </div>
    </>
  );

  return (
    <BaseEvent
      icon={<UploadSolidV6 />}
      title={title}
      interactedAt={event.interacted_at_absolute}
      onClick={() => setShowModal(true)}
    >
      {content}
      <Modal
        dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
        contentClassName="tw-max-w-[480px] tw-w-full tw-max-h-[90vh] tw-flex tw-flex-col tw-gap-[32px]"
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header title="Document" closeButton />
        <Modal.Body>
          {title}
          {content}
        </Modal.Body>
      </Modal>
    </BaseEvent>
  );
};

TimelineDocumentEvent.propTypes = {
  event: PropTypes.shape().isRequired,
};

export default TimelineDocumentEvent;
